import "../src/css/App.css";
import Form from "./components/Form";

function App() {
  return (
    <div className="App">
      <Form title="Contact Us" />
    </div>
  );
}

export default App;
